/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Resume_Role_FeInputs */

const en_resume_role_fe = /** @type {(inputs: Resume_Role_FeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Software Developer · Front-end`)
};

const ar_resume_role_fe = /** @type {(inputs: Resume_Role_FeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مطور برمجيات · واجهة أمامية`)
};

const bn_resume_role_fe = /** @type {(inputs: Resume_Role_FeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`সফটওয়্যার ডেভেলপার · ফ্রন্ট-এন্ড`)
};

const de_resume_role_fe = /** @type {(inputs: Resume_Role_FeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Softwareentwickler · Frontend`)
};

const es_resume_role_fe = /** @type {(inputs: Resume_Role_FeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desarrollador de Software · Frontend`)
};

const fr_resume_role_fe = /** @type {(inputs: Resume_Role_FeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Développeur de logiciels · Front-end`)
};

const pt_resume_role_fe = /** @type {(inputs: Resume_Role_FeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desenvolvedor de software · Front-end`)
};

const zh_resume_role_fe = /** @type {(inputs: Resume_Role_FeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`软件开发人员·前端`)
};

const tr_resume_role_fe = /** @type {(inputs: Resume_Role_FeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yazılım Geliştiricisi · Ön uç`)
};

const ru_resume_role_fe = /** @type {(inputs: Resume_Role_FeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Разработчик программного обеспечения · Front-end`)
};

const pl_resume_role_fe = /** @type {(inputs: Resume_Role_FeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Programista · Frontend`)
};

/**
* | output |
* | --- |
* | "Software Developer · Front-end" |
*
* @param {Resume_Role_FeInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const resume_role_fe = /** @type {((inputs?: Resume_Role_FeInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Resume_Role_FeInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_resume_role_fe(inputs)
	if (locale === "bn") return bn_resume_role_fe(inputs)
	if (locale === "de") return de_resume_role_fe(inputs)
	if (locale === "es") return es_resume_role_fe(inputs)
	if (locale === "fr") return fr_resume_role_fe(inputs)
	if (locale === "pt") return pt_resume_role_fe(inputs)
	if (locale === "zh") return zh_resume_role_fe(inputs)
	if (locale === "tr") return tr_resume_role_fe(inputs)
	if (locale === "ru") return ru_resume_role_fe(inputs)
	if (locale === "pl") return pl_resume_role_fe(inputs)
	return en_resume_role_fe(inputs)
});